export default {
  "signage.title": "サイネージ",
  "signage.url": "サイネージURL",
  "signage.informationSettings": "情報表示設定",
  "signage.workRemarks": "作品備考表示",
  "signage.restrict": "映倫表示",
  "signage.notification": "お知らせメッセージ",
  "signage.notification.tips": "※推奨32文字以内　32文字以上の場合、文字が流れるようになります",
  "signage.switchSetting": "自動切替設定",
  "signage.switchSetting.page": "切替開始ページ",
  "signage.switchSetting.second": "スケジュール切替秒数",
  "signage.switchSetting.type.trailer": "予告編",
  "signage.switchSetting.type.photo": "写真",
  "signage.switchSetting.plsInputUrl": "予告編リンクを入力してください",
  "signage.switchSetting.plsInputSort": "順番を入力してください",
  "signage.switchSetting.plsInputShowSecond": "表示時間（秒）を入力してください",
  "signage.switchSetting.plsSelectType": "種類選択してください",
  "signage.switchSetting.plsSelectPhoto": "写真選択してください",
  "signage.switchSetting.showSecond": "表示時間（秒",
};